import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query {
    regions {
      id
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/RegionQueries.ts